export const getAttachmentUrl = (attchUrl) => {
  if (attchUrl.indexOf("https://") === 0 || attchUrl.indexOf("http://") === 0) {
    return attchUrl;
  }
  return `https://assets.toothsi.in/chat-app-uploads/${attchUrl}`;
};

export const getExtension = (attchUrl = "") =>
  attchUrl.split(".")[1].toUpperCase();

// const urlRegex = () =>
//   /((?<!\+)https?:\/\/(?:www\.)?(?:[-\w.]+?[.@][a-zA-Z\d]{2,}|localhost)(?:[-\w.:%+~#*$!?&/=@]*?(?:,(?!\s))*?)*)/g;

const urlRegex = () =>
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/

const telRegex = () => /([0|\+[0-9]{1,5})?([7-9][0-9]{9})/g;
const emailRegex = () =>
  /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g;

export const linkify = (text = "") => {
  try {
    const intme = text
      .replace(urlRegex(), (match) => {
        return `<a href="${match}" target="_blank" rel="noreferrer" class="chat__text-links">${match}</a>`;
      })
      .replace(emailRegex(), (match) => {
        return `<a href="mailto://${match}" class="chat__text-links">${match}</a>`;
      });
    return intme.replace(telRegex(), (match) => {
      return `<a href="tel://${match}" class="chat__text-links">${match}</a>`;
    });
  } catch (e) {
    return text;
  }
};
